import { getNumberSeparators } from "app/tools/number"
import React from "react"
import { InputAttributes, NumericFormat } from "react-number-format"

// mui.com/material-ui/react-text-field/#integration-with-3rd-party-input-libraries

interface INumberInputProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

export const NumberInput = React.forwardRef<typeof NumericFormat<InputAttributes>, INumberInputProps>(
  function NumberInput(props, ref) {
    const { onChange, ...other } = props
    const separators = getNumberSeparators()
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={values =>
          onChange({
            target: {
              name: props.name,
              value: values.value
            }
          })
        }
        thousandSeparator={separators[0]}
        decimalSeparator={separators[1]}
        valueIsNumericString
      />
    )
  }
)
